// MD5 (RFC 1321) over a byte array. Here because Synthesia keys its metadata
// to the base64 MD5 of the music file (crypto.subtle deliberately omits MD5).
// Not for security — content identity only.

S := [
  7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22
  5,  9, 14, 20, 5,  9, 14, 20, 5,  9, 14, 20, 5,  9, 14, 20
  4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23
  6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21
]

// K[i] = floor(abs(sin(i + 1)) * 2^32)
K := [0...64].map (i) ->
  Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000) >>> 0

rotl := (x: number, c: number) ->
  (x << c) | (x >>> (32 - c))

export md5 := (bytes: Uint8Array): Uint8Array ->
  // Pad: 0x80, zeros to 56 mod 64, then the bit length as a 64-bit LE integer
  bitLen := bytes.length * 8
  paddedLength := (((bytes.length + 8) >> 6) + 1) << 6
  padded := new Uint8Array paddedLength
  padded.set bytes
  padded[bytes.length] = 0x80
  view := new DataView padded.buffer
  view.setUint32 paddedLength - 8, bitLen >>> 0, true
  view.setUint32 paddedLength - 4, Math.floor(bitLen / 0x100000000), true

  a0 .= 0x67452301
  b0 .= 0xefcdab89
  c0 .= 0x98badcfe
  d0 .= 0x10325476

  m := new Uint32Array 16

  offset .= 0
  while offset < paddedLength
    for i of [0...16]
      m[i] = view.getUint32 offset + i * 4, true

    a .= a0
    b .= b0
    c .= c0
    d .= d0

    for i of [0...64]
      let f: number, g: number
      if i < 16
        f = (b & c) | (~b & d)
        g = i
      else if i < 32
        f = (d & b) | (~d & c)
        g = (5 * i + 1) % 16
      else if i < 48
        f = b ^ c ^ d
        g = (3 * i + 5) % 16
      else
        f = c ^ (b | ~d)
        g = (7 * i) % 16

      tmp := d
      d = c
      c = b
      b = (b + rotl((a + f + K[i] + m[g]) >>> 0, S[i])) >>> 0
      a = tmp

    a0 = (a0 + a) >>> 0
    b0 = (b0 + b) >>> 0
    c0 = (c0 + c) >>> 0
    d0 = (d0 + d) >>> 0

    offset += 64

  digest := new Uint8Array 16
  out := new DataView digest.buffer
  out.setUint32 0, a0, true
  out.setUint32 4, b0, true
  out.setUint32 8, c0, true
  out.setUint32 12, d0, true
  digest

export md5Hex := (bytes: Uint8Array): string ->
  [...md5 bytes].map (b) ->
    b.toString(16).padStart 2, "0"
  .join ""

// Synthesia's UniqueId encoding
export md5Base64 := (bytes: Uint8Array): string ->
  btoa String.fromCharCode ...md5 bytes
